import { Spinner } from "@chakra-ui/react"
import { Tag } from "../Tag"

type Props = {
  count?: number
  hideParentheses?: boolean
  variant?: "outline" | "round" | "subtle" | "nostyle" | (string & {})
}

export const CountTag: React.FC<Props> = ({ count, hideParentheses, variant }) => {
  if (count === undefined) {
    return <Spinner size="xs" ml="2" />
  }

  if (variant === "nostyle") return <>{hideParentheses ? count : `(${count})`}</>

  return (
    <Tag variant={variant ?? "round"} marginLeft={2}>
      {hideParentheses ? count : `(${count})`}
    </Tag>
  )
}
